import { computed, defineComponent, inject, onMounted, ref } from "vue";
import gsap from "gsap";
export default defineComponent({
  props: {
    slides: { type: Array, required: true },
    startAt: { type: Number, default: 0 },
    showSlideCount: { type: Boolean, default: true },
  },
  setup(props) {
    const emitter = inject("emitter");

    const currentSlide = ref(props.startAt);
    const containerElement = ref<HTMLElement | null>(null);
    const sliderElement = ref<HTMLElement | null>(null);
    const slideElements = ref<HTMLElement[] | null>(null);
    const sliderControls = ref<HTMLElement | null>(null);
    const totalSlides = computed(() => props.slides.length);
    const formatTwoDecimal = (number: number): string => {
      return number.toString().padStart(2, "0");
    };
    const nextSlide = (): void => {
      if (currentSlide.value < totalSlides.value - 1) {
        currentSlide.value++;
        animateSlider();
      }
    };
    const prevSlide = (): void => {
      if (currentSlide.value > 0) {
        currentSlide.value--;
        animateSlider();
      }
    };
    const gotoSlide = (index: number): void => {
      if (index < totalSlides.value) {
        currentSlide.value = index;
        animateSlider();
      }
    };

    const animateSlider = (): void => {
      const containerDomRect = containerElement.value?.getBoundingClientRect();
      const activeSlideDomRect =
        slideElements.value![currentSlide.value].getBoundingClientRect();

      gsap.to(sliderElement.value, {
        x: `+=${(activeSlideDomRect.x - containerDomRect!.x) * -1}`,
        duration: 0.6,
        ease: "power4.out",
      });

      if (sliderControls.value !== null) {
        if (
          sliderControls.value!.querySelectorAll(
            ".photoslider__caption--current"
          ).length
        ) {
          gsap.to(
            sliderControls.value!.querySelector(
              ".photoslider__caption--current"
            ),
            {
              yPercent: -100,
              duration: 0.2,
              autoAlpha: 1,
              ease: "power4.out",
              onComplete: () => {
                sliderControls
                  .value!.querySelector(".photoslider__caption--current")!
                  .classList.remove("photoslider__caption--current");
              },
            }
          );
        }

        gsap.fromTo(
          sliderControls.value!.querySelector(
            `[data-caption='${currentSlide.value}'`
          ),
          { yPercent: 100, autoAlpha: 0 },
          {
            yPercent: 0,
            duration: 0.2,
            autoAlpha: 1,
            ease: "power4.out",
            onComplete: () => {
              sliderControls
                .value!.querySelector(`[data-caption='${currentSlide.value}'`)!
                .classList.add("photoslider__caption--current");
            },
          }
        );
      }
    };

    onMounted(() => {
      const elementSlideNodes =
        containerElement.value!.querySelectorAll(".slide");
      const elementArray = [];

      for (let i = 0; i < elementSlideNodes.length; i++) {
        const node: Node = elementSlideNodes[i];

        elementArray.push(node as HTMLElement);
      }

      slideElements.value = elementArray;
      animateSlider();

      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore:next-line
      emitter.on("screen-size-changed", () => {
        animateSlider();
      });
    });

    return {
      containerElement,
      sliderElement,
      sliderControls,
      currentSlide,
      totalSlides,
      formatTwoDecimal,
      nextSlide,
      prevSlide,
      gotoSlide,
    };
  },
});
